import { Carousel } from "react-responsive-carousel";
import "./presentation.scss"

export default function Landing() {

    return (
        <>
            <div>
                <h1>Login with google</h1>
            </div>
        </>
    );

}